import React from 'react'

const IconTag = () => (
  <svg width="15px" height="15px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <g stroke="none" strokeWidth="1" fill="currentColor" fillRule="evenodd">
      <path
        d="M20.9246212,2.5753788 L20.9246212,11.767767 L11.0251263,21.6672619 L1.83273811,12.4748737 L11.732233,2.5753788 L20.9246212,2.5753788 Z M18.9242161,4.57578388 L12.5609622,4.57507677 L4.66116524,12.4748737 L11.0251263,18.8388348 L18.9242161,10.9397449 L18.9242161,4.57578388 Z M16.3284271,7.17157288 C16.9142136,7.75735931 16.9142136,8.70710678 16.3284271,9.29289322 C15.7426407,9.87867966 14.7928932,9.87867966 14.2071068,9.29289322 C13.6213203,8.70710678 13.6213203,7.75735931 14.2071068,7.17157288 C14.7928932,6.58578644 15.7426407,6.58578644 16.3284271,7.17157288 Z"
        fillRule="nonzero"
      />
    </g>
  </svg>
)

export default IconTag
